<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <!-- logo -->
        <div class="logo">
          <img v-if="bannerArr.length > 0" :src="$imgUrl+bannerArr[0].thumb" alt="" />
        </div>
        <!-- 内容区 -->
        <div class="apply-success">
          <img
            class="icon"
            v-if="bannerArr.length > 0"
            :src="$imgUrl+'/uploads/images/20240604/success.png'"
            alt=""
          />
          <div>提交成功</div>
          <div class="btn" @click="toHome">完成</div>
        </div>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import { getBanner } from "@/api/api";
export default {
  components: { top, bottom },
  name: "home",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: "BCEIA-参展申请",
      meta: [
        {
          name: "description",
          content: "北京分析测试学术报告会暨展览会参展申请",
        },
      ],
    };
  },
  data() {
    return {
      langSet: "",
      bannerArr: [],
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
  },
  methods: {
    // zhang 获取展会服务banner
    getBannerList() {
      let data = {
        class: "参展流程",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //dxm 点击完成跳转首页
    toHome() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  width: 100%;
  height: 400px;
  img {
    width: 100%;
    height: 400px;
  }
}
.apply-success {
  padding: 61px 0;
  text-align: center;
  box-sizing: border-box;
  height: calc(100vh - 480px);
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  .icon {
    width: 121px;
    height: 121px;
    margin-bottom: 15px;
  }
  .btn {
    width: 242px;
    height: 48px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 48px;
    margin: 50px auto;
    background: linear-gradient(180deg, #4a69be 0%, #243889 100%);
    border-radius: 7px;
    cursor: pointer;
    &:hover {
      background: #243889;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .logo {
    width: 100%;
    height: auto;
    img {
      width: 100%;
      height: auto;
    }
  }
}
@media only screen and (max-width: 767px) {
  .apply-success {
    height: calc(100vh - 350px);
  }
}
</style>